import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { contractsApi } from './api/contractsApi';
import { customersApi } from './api/customersApi';
import { ordersApi } from './api/ordersApi';
import { staticApi } from './api/staticApi';
import { workflowsApi } from './api/workflowsApi';

const rootReducer = combineReducers({
  [ordersApi.reducerPath]: ordersApi.reducer,
  [customersApi.reducerPath]: customersApi.reducer,
  [contractsApi.reducerPath]: contractsApi.reducer,
  [staticApi.reducerPath]: staticApi.reducer,
  [workflowsApi.reducerPath]: workflowsApi.reducer
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) => getDefault()
    .concat(ordersApi.middleware)
    .concat(customersApi.middleware)
    .concat(contractsApi.middleware)
    .concat(staticApi.middleware)
    .concat(workflowsApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;